module.exports = __webpack_public_path__ + "img/部分中标@3x.70824c1e.png";